import React from "react";
import { Link } from "react-router-dom";
import paths from "../../routes/paths";
import {
  imageCodes,
  titleCodes,
  textCodes,
  videoCodes,
} from "../../template_codes/next/home_page_codes";
import banner from "../../assets/images/next/banner.png";

export default function Home() {
  return (
    <div>
      <div className="navbar ">
        <div class="navbar-start"></div>
        <div class="navbar-center lg:flex">
          <ul class="menu menu-horizontal">
            <li className="p-1">
              <Link to={paths.home}>Home</Link>
            </li>
            <li>
              <a href="">Shop</a>
            </li>
            
            <li className="p-1">
              <Link to={paths.contact}>Contact</Link>
            </li>
          </ul>
        </div>
        <div className="navbar-end"></div>
      </div>

      {/*               banner section          */}
      <div className=" hero w-full h-52 pb-10 lg:h-1/3 xl:h-1/3">
        <img
          src={banner}
          className="py-1 w-full h-48 md:h-full lg:h-full xl:h-full"
        />
        <div class="hero-content text-center text-neutral-content">
          <div class="max-w-md">
            <h1 className="text-lg lg:text-2xl xl:text-2xl pt-10 lg:pt-40 xl:pt-40 font-bold text-[#000000] py-4">
              Buy Online & We Deliver
            </h1>
            <button className="btn btn-outline btn-white btn-xs lg:btn-sm xl:btn-md btn-outline text-[#000000]">
              <a href="https://nextgadgetshop.com/"> S h o p N o w </a>
            </button>
          </div>
        </div>
      </div>
      {/*             end of banner section       */}

      {/*                 grid column              */}
      <div className="grid grid-cols-3 px-5">
        <div>
          <img src={imageCodes.gr.image} alt="pos" className="p-5"></img>
        </div>
        <img src={imageCodes.gr1.image} alt="phone" className="p-5"></img>
        <img src={imageCodes.gr2.image} alt="computer" className="p-5"></img>
      </div>
      {/*               end of grid column          */}

      {/*                 category section           */}
      <div className="container w-5/6 md:w-4/6 lg:w-4/6 xl:w-4/6 2xl:w-3/6 pt-10 pb-16">
        <div className="grid grid-cols-6 md:grid-cols-3 lg:grid-cols-6 xl:grid-cols-6 2xl:grid-cols-6 gap-x-4 md:gap-x-8 lg:gap-x-8 xl:gap-x-8 2xl:gap-x-8 gap-y-4">
          <div className="">
            <a href="#">
              <img
                src={imageCodes.cat.image}
                alt="addidas"
                className="hover:-translate-y-1 duration-300 ..."
              ></img>
              <p className="text-center">ACEFAST COLLECTION</p>
            </a>
          </div>
          <div className="">
            <a href="#">
              <img
                src={imageCodes.cat1.image}
                alt="nike"
                className="hover:-translate-y-1 duration-300 ..."
              ></img>
              <p className="text-center">ASUS</p>
            </a>
          </div>
          <div className="">
            <a href="#">
              <img
                src={imageCodes.cat2.image}
                alt="Wila Heels / Sandals"
                className="hover:-translate-y-1 duration-300 ..."
              ></img>
              <p className="text-center">AUKEY Gadgets</p>
            </a>
          </div>
          <div className="">
            <a href="#">
              <img
                src={imageCodes.cat3.image}
                alt="slides"
                className="hover:-translate-y-1 duration-300 ..."
              ></img>
              <p className="text-center">BARMASO</p>
            </a>
          </div>
          <div className="">
            <a href="#">
              <img
                src={imageCodes.cat4.image}
                alt="clothing"
                className="hover:-translate-y-1 duration-300 ..."
              ></img>
              <p className="text-center">Belkin Collection</p>
            </a>
          </div>
          <div className="">
            <a href="#">
              <img
                src={imageCodes.cat5.image}
                alt="sabina"
                className="hover:-translate-y-1 duration-300 ..."
              ></img>
              <p className="text-center">Epson Printer</p>
            </a>
          </div>
        </div>
      </div>
      {/*             end of category section           */}

      {/*              hero product section             */}
      <div className="w-fix">
        <div className="grid grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 pb-20 lg:px-20 xl:px-20 px-4">
          <div className="lg:pl-2 xl:pl-2">
            <img src={imageCodes.hero.image}></img>
            <a href="https://herandcomm.com/product/sGJg3r9VsbnUkQAXol2k"></a>
          </div>
          <div className="text-center pt-10 lg:pt-40 xl:pt-40 lg:pr-2 xl:pr-2 focus-visible">
            <h1 className="pr-2 lg:text-2xl xl:text-2xl"> About NeXT</h1>
            <p className="text-sm pt-5 lg:text-xl xl:text-xl lg:pt-10 xl:pt-10">
              Computer, Mobile Phones, Point of Sales Devices, Digital Gadgets
              and other accessories shop
            </p>
          </div>
        </div>
      </div>
      {/*           end of hero product section          */}

      {/*              best seller section               */}
      <div className="w-fix">
        <div className="pt-10 lg:pt-10 xl:pt-10">
          <h1 className="text-xl lg:text-2xl xl:text-2xl font-semibold text-center pb-5">
            {titleCodes.title.title}
          </h1>
        </div>

        <div className="container grid grid-cols-2 lg:grid-cols-4 xl:grid-cols-4 pt-10 px-4">
          <div className="p-2 hover:-translate-y-1 duration-300 ...">
            <div class="card w-40 md:w-40 l:w-48 xl:w-48 md:mb-8 shadow-xl hover:animate-pulse">
              <a href="">
                <figure>
                  <img src={imageCodes.top1.image} alt="top1" />
                </figure>
              </a>
              <div class="card-body">
                <h5 class="card">ACEFAST A39</h5>
              </div>
            </div>
          </div>
          <div className="p-2 hover:-translate-y-1 duration-300 ...">
            <div class="card w-40 md:w-40 l:w-48 xl:w-48 md:mb-8 bg-base-100 shadow-xl hover:animate-pulse">
              <a href="">
                <figure>
                  <img src={imageCodes.top2.image} alt="top2" />
                </figure>
              </a>
              <div class="card-body">
                <h5 class="card">Label Printer</h5>
              </div>
            </div>
          </div>
          <div className="p-2 hover:-translate-y-1 duration-300 ...">
            <div class="card w-40 md:w-40 l:w-48 xl:w-48 md:mb-8 bg-base-100 shadow-xl hover:animate-pulse">
              <a href="">
                <figure>
                  <img src={imageCodes.top3.image} alt="top3" />
                </figure>
              </a>
              <div class="card-body">
                <h5 class="card">ACEFAST A15</h5>
              </div>
            </div>
          </div>
          <div className="p-2 hover:-translate-y-1 duration-300 ...">
            <div class="card w-40 md:w-40 l:w-48 xl:w-48 md:mb-8 bg-base-100 shadow-xl hover:animate-pulse">
              <a href="">
                <figure>
                  <img src={imageCodes.top4.image} alt="top4" />
                </figure>
              </a>
              <div class="card-body">
                <h5 class="card">ACEFAST</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/*          end of best seller section            */}
      {/*              collaboration brand               */}
      <div className="items-center text-center w-full ">
        <div>
          <div className="text-center pt-10 pb-10">
            <h1 className="text-xl lg:text-2xl xl:text-2xl font-semibold text-center">
              {titleCodes.title1.title}
            </h1>
          </div>
        </div>
        <div className="grid lg:text-center xl:text:centerlg:grid-cols-6 xl:grid-cols-6 gap-0">
          
          
            <div class="avatar text-center">
              <div class="w-30 rounded text-center">
                <img src={imageCodes.cat.image} className="text-center" />
              </div>
            </div>
            <div class="avata text-center">
              <div class="w-30 rounded md:text-center">
                <img
                  src={imageCodes.cat2.image}
                  className="md:text-center"
                />
              </div>
            </div>
            <div class="avatar text-center">
              <div class="w-30 rounded text-center">
                <img src={imageCodes.cat3.image} className="text-center" />
              </div>
            </div>
            <div class="avatar text-center">
              <div class="w-30 rounded md:text-center">
                <img
                  src={imageCodes.cat5.image}
                  className="md:text-center"
                />
              </div>
            </div>
            <div class="avatar text-center">
              <div class="w-30 rounded md:text-center">
                <img
                  src={imageCodes.cat6.image}
                  className="md:text-center"
                />
              </div>
            </div>
            <div class="avatar text-center">
              <div class="w-30 rounded md:text-center">
                <img
                  src={imageCodes.cat4.image}
                  className="md:text-center"
                />
              </div>
            </div>
            
          
          
        </div>
      </div>
      {/*          end of collaboration brand            */}
    </div>
  );
}
